import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { TreeSelect } from 'primereact/treeselect';
import { Button } from '../../../../../components/ui/Button';

import { formatDuration, } from "../../../../../config/global";

import AddContentPopup from '../../../../SharedComponents/AddContentPopup/AddContentPopup';
import DragDrop from '../../../../SharedComponents/DragDrop/DragDrop';

import { setIsAdScreen, setIsAnimationScreen, setMediaDelayDuration, setScreenDetails, setScreenMedia, updateCampaignDuration, updateCampaignMuted } from '../../../../../redux/Slices/layoutSlice';
import { usePublishScreensMutation, useGetCampaignLayerContent, useResetCampaignMutation, useRetrieveMediaDuration } from '../../../../../queries';
import { toggleDialog } from '../../../../../redux/Slices/Global/globalSlice';
import { useSelector, useDispatch } from 'react-redux';
import FirebaseMediaListener from '../../../../Services/FirebaseMediaListener';
import ScreenAnimationSettings from './ScreenAnimationSettings';
import { useLocation } from 'react-router-dom';

const ScreenInfo = ({ onPublish }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();

    const { screens_setting, screenDetails } = useSelector((state) => state.layout);
    const { openDialog, mediaIdReset } = useSelector((state) => state.global);
    const isAnimatedLayout = location.pathname.startsWith('/apps/animated_layouts');

    const { data, isLoading: campaignLoading, refetch } = useGetCampaignLayerContent(screenDetails?.id, "MAIN");
    const { mutate: publishScreen } = usePublishScreensMutation();
    // const resetCampaign = useResetCampaignMutation()

    const [selectedScreen, setSelectedScreen] = useState(screenDetails?.id);
    const options = [
        {
            label: t('layouts.setup_add_content'),
            icon: 'pi pi-plus',
            command: () => {
                dispatch(toggleDialog("addContent"))
            }
        },
        {
            label: t('layouts.setup_publish_layout'),
            icon: '',
            command: () => {
                publishScreen()
            }
        },
        // {
        //     label: 'Reset',
        //     visible: screenDetails?.status === "DRAFT",
        //     icon: '',
        //     command: () => {
        //         reset()
        //     }
        // }
    ];

    // const reset = async () => {
    //     await resetCampaign.mutateAsync({ id: screenDetails?.id, name: screenDetails?.name })
    // }

    const treeNodes = screens_setting.map(screen => ({
        key: screen.id,
        label: screen.name,
        data: screen,
        children: (screen.related_screen || []).map(child => ({
            key: child.id,
            label: child.name,
            data: child
        }))
    }));

    // Fetch Screen data 
    useEffect(() => {
        dispatch(setScreenMedia(data?.length ?? 0));
    }, [data]);

    const handleScreenChange = (e) => {
        const selectedKey = e.value;

        const allNodes = treeNodes.flatMap(node =>
            [node, ...(node.children || [])]
        );
        const selectedNode = allNodes.find(n => n.key === selectedKey);

        const selectedData = selectedNode?.data;
        setSelectedScreen(selectedData.id)
        if (selectedNode?.children) {
            // It's a parent screen
            dispatch(setIsAdScreen(selectedData?.settings?.live?.is_Ad_Screen_Enabled));
            dispatch(setIsAnimationScreen(selectedData?.settings?.live?.is_Animate_Screen_Enabled));
            dispatch(updateCampaignDuration(selectedData?.campaign_duration));
            dispatch(updateCampaignMuted(selectedData?.settings?.live.is_muted));
            dispatch(setScreenDetails(selectedData));
            dispatch(setMediaDelayDuration(selectedData.settings?.live.media_delay_duration ?? 0))
        } else {
            // It's a child (advertisement slot)
            dispatch(setScreenDetails(selectedData));
            dispatch(setMediaDelayDuration(selectedData.settings?.live.media_delay_duration ?? 0))
        }

    };



    const mediaIdResetRef = useRef(mediaIdReset);

    const retrieveNewMediaDuration = useRetrieveMediaDuration()

    const galleryRefetch = useCallback(async () => {
        const currentMediaIds = mediaIdResetRef?.current;
        if (currentMediaIds?.length > 0) {
            for (const element of currentMediaIds) {
                await retrieveNewMediaDuration.mutateAsync({ id: element });
            }
        }

        // refetch();
    }, []);



    useEffect(() => {
        mediaIdResetRef.current = mediaIdReset;
    }, [mediaIdReset])

    return (
        <>
            <div className="p-0 d-flex justify-content-between mb-3">
                <div className="col-8 col-md-9 d-flex">


                    <TreeSelect value={screenDetails?.id}
                        selectionMode="single"
                        showClear={false}
                        options={treeNodes}
                        panelHeaderTemplate
                        onChange={handleScreenChange}
                        placeholder={t('layouts.setup_select_screen')}
                        className="w-50"
                    />
                    <div className='mx-3 d-none d-sm-block'>
                        <p className="mb-0 ">{t('layouts.setup_total_duration')}</p>
                        <div className='fw-bold'> {formatDuration(screenDetails?.campaign_duration ?? "0")}</div>
                    </div>
                    {/* <Button label="Discard" className='py-1 mr-1 p-button-outlined p-button-danger'
                        onClick={reset}
                        visible={screenDetails?.status === "DRAFT"}
                        loading={resetCampaign.isLoading}
                    /> */}
                </div>
                <div className='d-none d-md-flex'>
                    <div className="d-none d-md-flex">
                        {!isAnimatedLayout && (


                            <Button
                                className="mr-1 py-2 p-button-outlined p-button-secondary"
                                onClick={() => dispatch(toggleDialog("screenSettings"))}
                                // disabled={loading}
                                icon={<i className="pi pi-cog" />}
                                onMouseEnter={(e) => e.currentTarget.querySelector('.pi').classList.add('pi-spin')}
                                onMouseLeave={(e) => e.currentTarget.querySelector('.pi').classList.remove('pi-spin')}
                            />
                        )}
                    </div>
                    <Button label={t('layouts.setup_add_content')} icon="bx bx-plus-circle " className='py-1  p-button-outlined p-button-secondary '
                        onClick={() => dispatch(toggleDialog("addContent"))}
                        disabled={campaignLoading} />
                </div>
                <SplitButton label={t('layouts.setup_option')} model={options} className="  mr-2 mb-2 d-flex d-md-none" />


            </div>



            {
                data?.length === 0 && !campaignLoading ?
                    <h5 className='w-100 card d-flex align-items-center text-center p-5 mt-5'>
                        {t('layouts.setup_no_media_assigned')}
                    </h5>
                    :
                    ""
            }
            {
                campaignLoading && !data ? (
                    <div className="w-100 h-100 d-flex align-items-center">
                        <ProgressSpinner style={{ width: '60px', height: '60px', opacity: .1 }} strokeWidth="3" fill="var(--surface-ground)" animationDuration="1s" />
                    </div>
                ) : data?.length ? (
                    <DragDrop data={data} onPublish={onPublish} showDuration={true} centeredDuration={true} />
                ) : null
            }

            {openDialog.addContent && <AddContentPopup />}
            {openDialog.screenSettings && <ScreenAnimationSettings />}



            <FirebaseMediaListener
                path={"/Companies/" + localStorage.getItem("company_id") + "/actions"}
                getData={galleryRefetch}
            />
        </>
    );
};

export default ScreenInfo;